import {
    ChangeDetectionStrategy,
    Component,
    Input,
    ViewEncapsulation,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import {
    FormComponent,
    IFormFields,
} from '@components/ui-upsert-page/ui-form.component';
import { StopStrategy } from '@models';

import {
    ITriggerStopAfter,
    STOP_DAYS_MAX,
    STOP_HOURS_MAX,
    STOP_MINUTES_MAX,
} from '../trigger.upsert.page.models';

@Component({
    selector: 'ui-stop-after',
    templateUrl: './stop-after.component.html',
    styleUrls: ['./stop-after.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class StopAfterComponent extends FormComponent<ITriggerStopAfter>  {
    public StopStrategy = StopStrategy;

    public get stopDaysMax() { return STOP_DAYS_MAX; }
    public get stopHoursMax() { return STOP_HOURS_MAX; }
    public get stopMinutesMax() { return STOP_MINUTES_MAX; }

    @Input()
    public form!: FormGroup;

    @Input()
    public fields!: IFormFields<ITriggerStopAfter>;

    @Input()
    public disabled = false;

    public changedStopJob(toggle: boolean) {
        const stopStrategy = this.getField('stopStrategy');
        const stopFields = this.getFields(
            'stopDays',
            'stopHours',
            'stopMinutes',
        );

        stopStrategy.setValue(
            toggle ?
                StopStrategy.SoftStop :
                null,
        );

        if (toggle) {
            stopFields.forEach(f => f.enable());
        } else {
            stopFields.forEach(f => f.disable());
        }
    }
}
